import { render } from "./UsuarioSusc.vue?vue&type=template&id=2bf09a5a&scoped=true"
import script from "./UsuarioSusc.vue?vue&type=script&lang=js"
export * from "./UsuarioSusc.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=2bf09a5a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf09a5a"]])

export default __exports__